var n = () => typeof navigator > "u" ? !1 : navigator.userAgent.includes("ZRAPP"), s = (e, t) => {
  const i = {
    command: e,
    data: t
  };
  window.ReactNativeWebView?.postMessage(JSON.stringify(i));
}, a = (e, t) => {
  n() && s(e, t);
}, g = () => {
  n() && s("closeModal");
}, l = (e) => {
  if (!e || !n()) return null;
  (() => {
    const o = e.scrollHeight;
    s("dashboardHeight", o);
  })();
  let i = e.scrollHeight;
  const r = new ResizeObserver(() => {
    const o = e.scrollHeight;
    o !== i && (i = o, s("dashboardHeight", o));
  });
  return r.observe(e), () => r.disconnect();
}, d = (e) => {
  s("handleIntegrationOAuth", e);
}, h = (e, t) => {
  s("openPDF", {
    pdf: e,
    title: t
  });
};
export {
  g as closeMobileAppModal,
  n as isMobileAppClient,
  s as postCommandToMobileApp,
  d as postHandleIntegrationOAuthMessage,
  h as postPDFMessageToMobileApp,
  a as sendMessageToAppClient,
  l as startDashboardHeightMonitoring
};

//# sourceMappingURL=mobile.helper.js.map